<div *transloco="let t; prefix 'registration.page.summary'">
  <div class="form-container">
    <htx-data-display [title]="t('userDetails')" [icon]="'person'" [data]="userDetails()" ></htx-data-display>

    <div class="summary-organisation-section">
      <h3 class="summary-section-title">
        <span class="material-icons">business</span>
        {{ t('organisationDetails') }}
      </h3>

      <htx-data-display [title]="t('organisationGroups.basic')" [data]="organisationDetails()"></htx-data-display>
      <hr class="summary-divider">
      <htx-data-display [title]="t('organisationGroups.address')" [data]="organisationAddressDetails()"></htx-data-display>
      <hr class="summary-divider">
      <htx-data-display [title]="t('organisationGroups.legal')" [data]="organisationLegalDetails()"></htx-data-display>
      <hr class="summary-divider">
      <htx-data-display [title]="t('organisationGroups.more')" [data]="organisationMoreDetails()"></htx-data-display>
    </div>
  </div>
</div>
